import StudentSubsidyCreate from "./StudentSubsidyCreate";
import StudentSubsidyEdit from "./StudentSubsidyEdit";
import StudentSubsidyList from "./StudentSubsidyList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "studentSubsidies",
  create: StudentSubsidyCreate,
  edit: StudentSubsidyEdit,
  list: StudentSubsidyList,
};
